import axios from 'axios';

export const API_BASE_URL = "https://admin.avelacom.com/wp-json";
// export const API_BASE_URL = "https://avelacome.glivera.com/wp-json";

export const api = axios.create({
	baseURL: `${API_BASE_URL}`,
});